module.exports = __webpack_public_path__ + "img/account-bg.6f5fa430.png";